import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ObserversModule } from "@angular/cdk/observers";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SecondarySidebarComponent } from "./secondary-sidebar/secondary-sidebar.component";
import { TooltipModule, TypeaheadModule } from "ngx-bootstrap";
import { ParallaxDirective } from "./parallax/parallax.directive";
import { FormGroupDefaultDirective } from "./forms/form-group-default.directive";
import { ViewDirective } from "./view/view.directive";
import { pgCollapseModule } from "./collapse/collapse.module";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ContainerComponent } from "./container/container.component";
import { pageContainer } from "./container/page-container.component";
import { RouterModule } from "@angular/router";
import { MenuComponent } from "./menu/menu.component";
import { MenuAltComponent } from "./menu/menu-alt.component";
import { MenuIconComponent } from "./menu/menu-icon.component";

import { ListItemComponent } from "./list-view/list-item/list-item.component";
import { ListViewContainerComponent } from "./list-view/list-view-container/list-view-container.component";
import { pgRetinaDirective } from "./retina/retina.directive";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SiteNameLogoComponent } from "../../shared/site-name-logo/site-name-logo.component";
import { SiteLangComponent } from "../../shared/site-lang/site-lang.component";
import { pgDatePickerModule } from "./datepicker/datepicker.module";
import { ErrorInterceptor } from "../../error-interceptor";
import { AuthInterceptor } from "../../auth/auth-interceptor";
import { RecaptchaFormsModule } from "ng-recaptcha/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { FooterComponent } from "../../shared/footer/footer.component";
import { UpperCaseInputDirective } from "./input/input-uppercase.directive";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    ObserversModule,
    TypeaheadModule.forRoot(),
    PerfectScrollbarModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    pgDatePickerModule,
    HttpClientModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    SecondarySidebarComponent,
    ParallaxDirective,
    FormGroupDefaultDirective,
    UpperCaseInputDirective,
    ViewDirective,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    SiteNameLogoComponent,
    SiteLangComponent,
    FooterComponent
  ],
  exports: [
    SecondarySidebarComponent,
    ParallaxDirective,
    FormGroupDefaultDirective,
    UpperCaseInputDirective,
    ViewDirective,
    pgCollapseModule,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    TranslateModule,
    SiteNameLogoComponent,
    SiteLangComponent,

    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FooterComponent,
    TooltipModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ]
})
export class SharedModule {}
